import NanoBuffer from './nanobuffer';

const errorBuffer = new NanoBuffer(50);

const init = () => {
  const defaultConsoleError = console.error.bind(console);
  console.error = function () {
    defaultConsoleError(arguments);
    addError(JSON.stringify(arguments));
  };

  window.onerror = function myErrorHandler(msg, url, lineNo, columnNo, error) {
    const message = [
      `Message: ${msg}`,
      `URL: ${url}`,
      `Line: ${lineNo}`,
      `Column: ${columnNo}`,
      `Error object: ${JSON.stringify(error)}`,
    ].join(' - ');
    addError(message);
    return true;
  };
};

const addError = (message: any) => {
  errorBuffer.push(message);
};

const getBuffer = () => {
  return errorBuffer;
};

export default {
  init,
  addError,
  getBuffer,
};
